/**
 * @fileoverview Constants for the Hotline REST API
 * These constants define readonly values used throughout the application
 */

// ============================================================================
// API CONSTANTS
// ============================================================================

/**
 * Constants for special ratings
 */
export const SPECIAL_RATINGS = {
  WALL_OF_SHAME: "wallOfShame" as const,
  TAKE_OF_THE_DAY: "takeOfTheDay" as const,
} as const;

/**
 * Constants for rating IDs
 */
export const RATING_IDS = {
  WALL_OF_SHAME: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  TAKE_OF_THE_DAY: 6,
} as const;

/**
 * Constants for submission types
 */
export const SUBMISSION_TYPES = {
  TEXT: "text" as const,
  VOICE: "voice" as const,
} as const;

/**
 * Constants for API error codes
 */
export const API_ERROR_CODES = {
  INVALID_ARGUMENT: "invalid-argument" as const,
  AUTHENTICATION_REQUIRED: "authentication-required" as const,
  PERMISSION_DENIED: "permission-denied" as const,
  NOT_FOUND: "not-found" as const,
  INTERNAL_ERROR: "internal-error" as const,
  RATE_LIMIT_EXCEEDED: "rate-limit-exceeded" as const,
  APP_CHECK_FAILED: "app-check-failed" as const,
} as const;
